import {Component, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {ButtonBarComponent, IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITablesSelector} from "../../../../components/tables-selector/tables-selector.component";
import {isNullOrUndefOrEmpty} from "../../../../common";

@Component({
    selector: 'app-scene-block-browser',
    templateUrl: './block-browser.component.html',
    styleUrls: ['./block-browser.component.scss']
})
export class BlockBrowserComponent extends BlockBaseComponent {
    dataSource: Array<any> = [];
    displayedColumns: string[] = ['url'];
    options;
    highlightedRows = [];
    buttons: IButtonBar[] = [];

    @ViewChild('dtable') dtable: any;
    @ViewChild(ButtonBarComponent) addRemoveBarComponent: ButtonBarComponent;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
        this.options = ['sites'];

        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: '+'
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: '-'
            },

        ];
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        if (!this.sceneItem.Data[0].Webkit[0].Data[0]?.$) return this.dataSource = [{url: 'http://...'}];
        this.dataSource = this.sceneItem.Data[0].Webkit[0].Data[0]?.$?.urls.split(',').map((v) => ({url: v}));
    }

    inputEdited(index: number, field: ITablesSelector, value) {
        if (isNullOrUndefOrEmpty(value)) return;
        const values = this.sceneItem.Data[0].Webkit[0].Data[0].$.urls.split(',');
        values.splice(index, 1, value);
        const valueString = values.join(',');
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'urls',
                value: valueString,
                storePath: 'Data[0].Webkit[0].Data[0].$'
            }]
        });
    }

    onSelectedRow(row) {
        /** uncomment to support multi select **/
        /** this.highlightedRows.push(row) **/
        this.highlightedRows = [row];
    }

    onAdd(e) {
        const value = this.dataSource.map((v) => v.url);
        value.push('http://wwww...');
        const valueString = value.join(',');
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'urls',
                value: valueString,
                storePath: 'Data[0].Webkit[0].Data[0].$'
            }]
        });
    }

    onRemove(v) {
        if (this.highlightedRows.length === 0) return;
        const values = [];
        this.highlightedRows.forEach((i_selected) => {
            this.dataSource.forEach((item, index) => {
                if (item === i_selected) return;
                values.push(item.url);
            });
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'urls',
                value: values.join(','),
                storePath: 'Data[0].Webkit[0].Data[0].$'
            }]
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '5',
                label: this.translocoService.translate('general.refresh', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                name: "refresh",
                storePath: 'Data[0].Webkit[0].Data[0].$.refresh'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

